import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "../../components/mobile/header";
import Footer from "../../components/mobile/footer";
import Home from "../../pages/mobile/home";
import Mini from "../../pages/mobile/mini";
import Ecommerce from "../../pages/mobile/ecommerce";
import { Skeleton } from "antd";

const MobileApp: React.FC = () => {
    return (
        <>
            <Header />
            <div>
                <Router>
                    <Routes>
                        <Route path="/" element={
                            <Suspense fallback={<Skeleton/>}>
                                <Home />
                            </Suspense>
                        } />
                        <Route path="/mini" element={
                            <Suspense fallback={<Skeleton/>}>
                                <Mini />
                            </Suspense>
                        } />
                        <Route path="/ecommerce" element={
                            <Suspense fallback={<Skeleton/>}>
                                <Ecommerce />
                            </Suspense>
                        } />
                    </Routes>
                </Router>
            </div>
            <Footer />
        </>
    );
}

export default MobileApp;
